import SubNavItem from './SubNavItem';

export default SubNavItem;
